// composables/useSyncSales.ts

import { useNotify } from "./useNotify";
import { useSales } from "./useSales";

export const useSyncSales = () => {
  const { getAllOfflineSales, clearOfflineSales } = useSales();
  const { success, error } = useNotify();

  const syncOfflineSales = async () => {
    const offlineSales = await getAllOfflineSales();

    if (offlineSales.length === 0) {
      console.log("✅ No offline sales to sync.");
      return;
    }

    let attempt = 0;
    const maxRetries = 3;
    let synced = false;

    while (attempt < maxRetries && !synced) {
      try {
        console.log(`🔄 Sync attempt ${attempt + 1}...`);
        const { fetchData } = useApi();

        const { data, error: apiError } = await fetchData("/sync-sales", {
          method: "POST",
          body: { sales: offlineSales },
        });

        if (apiError) throw apiError;

        // After successful sync
        await clearOfflineSales();
        success(`✅ ${offlineSales.length} offline sales synced successfully.`);
        synced = true;
      } catch (err) {
        attempt++;
        console.error(`❌ Sync failed. Attempt ${attempt}`, err);

        if (attempt >= maxRetries) {
          error("❗ Failed to sync offline sales after 3 tries.");
        } else {
          // Small wait before next retry (optional, 2 seconds)
          await new Promise((resolve) => setTimeout(resolve, 2000));
        }
      }
    }
  };

  return { syncOfflineSales };
};
